<ym-sidebar >
    <ng-container *ngIf="organisationDocument" header>
        <ym-sidebar-header [company]="organisationDocument.name" [companyDescription]="organisationDocument.id"
          [showCopyDescription]="true"></ym-sidebar-header>
      </ng-container>
    <ng-container options>
        <ng-container *ngFor="let item of sidebarItems">
            <ym-sidebar-item [icon]="isActiveRoute(item.route)?item.activeIcon:item.icon" [label]="item.label"
                [routeLink]="item.route" [selected]="isActiveRoute(item.route)">
            </ym-sidebar-item>
        </ng-container>
    </ng-container>
    <ng-container footer>
        <div class="ym-w-full ym-bg-gray-10 ym-text-secondary ym-py-1">
            <span class="ym-mr-2 ym-font-sm">Version {{environment.appVersion}}</span>
            <!-- • -->
            <!-- <span class="ym-ml-2 ym-font-sm">Feedback</span> -->
            <!-- <app-sidebar-feedback></app-sidebar-feedback> -->
        </div>
    </ng-container>
</ym-sidebar>